import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import { useBindUserFileMutation, useUploadFileMutation, useUploadPdfMutation } from "config/api/waV1_user";
import { toggleError, toggleNoti } from "config/slice/message";
import { KEY_ERROR_UPLOADED_FAILED, KEY_LABEL_UPLOAD, KEY_NOTI_UPLOADED_SUCC, MODULE_UPLOADBTN } from "config/const/locale";

export default function UploadButton({
    uid,
    sid,
    usid,
    customFn,
    children,
    fileName,
}) {

    const { t } = useTranslation(MODULE_UPLOADBTN)
    const dispatch = useDispatch()
    const [upImgFn] = useUploadFileMutation()
    const [upPdfFn] = useUploadPdfMutation()
    const [bindUFFn] = useBindUserFileMutation()

    const handleUpload = (e) => {

        const files = Array.from(e.target.files)
        let send = upImgFn

        for (let i = 0; i < files.length; i++) {
            const formData = new FormData()

            if (fileName) formData.append('file', files[i], `${fileName} _${Date.now()}`)
            else formData.append('file', files[i])

            if (files[i].type == 'application/pdf') {
                send = upPdfFn
            } else {
                send = upImgFn
            }
            send(formData)
                .then(res => {
                    if (res.data?.url) {
                        bindUFFn({
                            "user_id": uid,
                            "service_id": sid,
                            "user_service_id": usid,
                            "doc_type": res.data?.type,
                            "file_path": res.data?.url
                        })
                            .then(
                                resp => {
                                    if (resp.data?.data) {
                                        dispatch(toggleNoti({
                                            indicator: true,
                                            msg: t(KEY_NOTI_UPLOADED_SUCC)
                                        }))
                                        if (customFn && (customFn instanceof Function)) customFn({
                                            doc_type: resp.data?.data?.user_service?.doc_type,
                                            file_path: resp.data?.data?.user_service?.file_path
                                        })
                                    }
                                    else {
                                        dispatch(toggleError({
                                            indicator: true,
                                            msg: t(KEY_ERROR_UPLOADED_FAILED)
                                        }))
                                    }
                                }
                            )
                            .catch(
                                rea => {
                                    dispatch(toggleError({
                                        indicator: true,
                                        msg: t(KEY_ERROR_UPLOADED_FAILED)
                                    }))
                                }
                            )
                    }
                })


        }
    }

    return (
        <Button component="label" >
            {children ?? t(KEY_LABEL_UPLOAD)}
            <input type="file" accept="image/*, application/pdf" multiple hidden onChange={handleUpload} />
        </Button>
    )
}
